import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VueI18n from "vue-i18n";
import less from "less";
import "./util/rem";
import "fullpage.js/vendors/scrolloverflow"; // Optional. When using scrollOverflow:true
import ElementUI from "element-ui";

import "element-ui/lib/theme-chalk/index.css";
// import './fullpage.scrollHorizontally.min' // Optional. When using fullpage extensions
import VueFullPage from "vue-fullpage.js";
import "swiper/swiper.min.css"; //这个样式我并没有找到，但百度都是这样，后面有我的引入方法；
import VueAwesomeSwiper from "vue-awesome-swiper";
import animated from "animate.css"; // npm install animate.css --save安装，再引入
import Vant from "vant";
import "vant/lib/index.css";
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak: "rQxHPQX1ua21rWnXzTbUh5KSSUbnefxR"
})
Vue.use(animated);
Vue.use(VueAwesomeSwiper);
Vue.use(VueFullPage);
Vue.use(ElementUI);
Vue.use(less);
Vue.use(VueI18n);
Vue.use(Vant);
import result from "./util/type";
// console.log(result);
import zh from "../config/zh";
import ru from "../config/ru";
import en from "../config/en"; // 创建vue-i18n实例i18n
import * as ScrollMagic from "scrollmagic"; // Or use scrollmagic-with-ssr to avoid server rendering problems
import { TweenMax, TimelineMax } from "gsap"; // Also works with TweenLite and TimelineLite
Vue.prototype.$isMobile = result;
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";

ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
const i18n = new VueI18n({
  // 设置默认语言
  locale: localStorage.getItem("locale") || "zh", //语言标识
  messages: {
    ru,
    en,
    zh,
  },
  fallbackLocale: "zh", //如果在message中找不到相应的键值将回退到原本的语言
  formatFallbackMessages: true, //如果在message中找不到相应的键值将回退到原本的语言
});
Vue.config.productionTip = false;
new Vue({
  el: "#app",
  i18n,
  router,
  data() {
    return {
      fullpage: undefined,
      destination: 0,
    };
  },
  components: { App },
  template: "<App/>",
});
